/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {CustomerContactListVO} from "../customer-contact-list-vo.model";

export class OpportunityContactListVO extends CustomerContactListVO {

  opportunityUuid: string | undefined = undefined;

}
